import { render, staticRenderFns } from "./CheckSuccess.vue?vue&type=template&id=6facb0d0&scoped=true&"
import script from "./CheckSuccess.vue?vue&type=script&lang=js&"
export * from "./CheckSuccess.vue?vue&type=script&lang=js&"
import style0 from "./CheckSuccess.vue?vue&type=style&index=0&id=6facb0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facb0d0",
  null
  
)

component.options.__file = "CheckSuccess.vue"
export default component.exports